import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';

import {
  fetchUploadFbmStickersXls,
  fetchGetFbmBarcodesXls,
  fetchDeletePostOrdersReturns,
} from '../../../../actions/orders';
import { showModal } from '../../../../actions/modal';

import { checkIsFbm } from '../../../../helpers';

import { fetchExpirationDaysCalculateBatch } from '../../../../actions/auth';
import { useState, useEffect } from 'react';
import {
  fetchUpdateOrderItems,
  fetchGetOrdersReturns,
  fetchPostOrdersReturns,
} from '../../../../actions/orders';
import { ORDER_TYPE, showExpirationDate } from '../../../../config';
import {
  fetchPostOrderReserveRepair,
  fetchPostOrderUpdateStatusFromWMS,
  fetchUpdateOrderType,
} from '../../../../actions/admin';
import SelectComponent from '../../../common/Select';
import styled from '@emotion/styled';
import { fetchOrderRollbackToEdit } from '../../../../actions/admin';
import { fetchOrderRollbackBeforeLoadingDocuments } from '../../../../actions/admin';
import useOnclickOutside from 'react-cool-onclickoutside';
import ExecuteYMTestScenario from './components/ExecuteYMTestScenario';
import { findUniqueObjects } from '../../../../helpers';
import EditOrderStatus from './components/EditOrderStatus';
import { fetchUploadStickerPalletsExcel } from '../../../../actions/items';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';

const SelectOrderType = styled.div`
  label {
    color: #f245d6;
    font-weight: 700;
    margin-bottom: 0;
  }

  label,
  div {
    padding: 0 7px;
  }

  .admin-button {
    display: block;
    padding: 7px 9px 7px 7px;
    margin-top: 5px;
    &:hover {
      cursor: pointer;
      background-color: #f8f9fa;
    }
  }
`;

export const DropDownItem = (props) => {
  const {
    withoutPermission = false,
    permissions,
    permissionKey,
    action,
    icon,
    text,
    style = {},
  } = props;

  const available =
    !withoutPermission && permissions && permissions[permissionKey]
      ? permissions[permissionKey].value
      : true;
  const onClickAction = available ? action : () => false;

  return (
    <div
      className={`dropdown-item ${!available ? 'help-tooltip-wrapper' : ''}`}
      onClick={onClickAction}
      style={style}
    >
      <i className={icon} /> {text}
      {!available && permissions[permissionKey].reason ? (
        <span className="help-tooltip" style={{ color: '#72747b' }}>
          {permissions[permissionKey].reason}
        </span>
      ) : null}
    </div>
  );
};

const ActionsMenuButton = (props) => {
  const {
    isNew,
    currentOrder,
    showActions,
    haveProductsWithoutReserve,
    permissions,
    setShowActions,
    handleUploadToFulfillment,
    handleSetDelivery,
    handleAcceptReturn,
    handleRefreshReserve,
    handleCancel,
    handleUpdateDeliveryResult,
    handleCopyOrder,
    handleImportFromExcel,
    handleSendEmail,
    handleOpenEditSale,
    handleOpenPhoneCallBack,
    shorted,
    currentWarehouse,
    handleExportExcel,
    defaultReserveOrders,
    handleInvoice,
    actualizeOrder,
    worksheetDataRequirements,
    handleApplyPreferredPacking,
  } = props;

  const dispatch = useDispatch();
  const { deliveryInfo } = useSelector((state) => state.orders);
  const authData = useSelector((state) => state.auth);
  const adminPanel = localStorage.getItem('adminPanel');
  const { usePackingMaterials } = useSelector((state) => state.auth.account);
  const worksheetShipmentCode = useSelector((state) => state.orders?.worksheetShipmentCode);

  const { t } = useAutoTranslation();

  let currentDelivery = null;

  const ref = useOnclickOutside(() => {
    setShowActions(false);
  });

  if (currentOrder.delivery) {
    currentDelivery = deliveryInfo.filter(
      (delivery) => delivery.deliveryCode === currentOrder.delivery.deliveryCode,
    );
  }
  const [expirationDaysPercent, setExpirationDaysPercent] = useState(null);

  const itemsWithUseExpiration = currentOrder?.items?.filter(
    (item) => item.expirationMode && item.expirationMode === 'USE_EXPIRATION',
  );

  const isItemsWithUseExpiration = () =>
    itemsWithUseExpiration && itemsWithUseExpiration.length > 0;

  const showUploadFulfillment = false;

  useEffect(() => {
    if (itemsWithUseExpiration && itemsWithUseExpiration.length > 0) {
      setExpirationDaysPercent(itemsWithUseExpiration[0]?.expirationDaysPercent);
    }
  }, [itemsWithUseExpiration]);

  const showCopy = !isNew;
  const showDelivery =
    [
      'ORDER_INFO_SHIPPED',
      'ORDER_INFO_COUIRIER',
      'ORDER_INFO_AT_TAKEOUT_POINT',
      'ORDER_INFO_LOST',
    ].indexOf(currentOrder.status) !== -1;
  const showReturn =
    [
      'ORDER_INFO_RETURNING',
      'ORDER_INFO_LOST',
      'ORDER_INFO_PARTIALLY_DELIVERED_NOT_RETURNED',
      'ORDER_INFO_SORT_CENTER_RETURNED_AND_SHIPPED',
      'ORDER_INFO_SORT_CENTER_PARTIALLY_RETURNED_AND_SHIPPED',
    ].indexOf(currentOrder.status) !== -1;
  const showCancel =
    [
      'ORDER_INFO_DRAFT',
      'ORDER_INFO_NEW',
      'ORDER_INFO_NEED_CONFIRM',
      'ORDER_INFO_INSUFFICIENT_RESERVE',
      'ORDER_INFO_REQUIRE_PAYMENT',
      'ORDER_INFO_READY_TO_PACK',
      'ORDER_INFO_CONFIRM_HOLD',
      'ORDER_INFO_PACKED',
      'ORDER_INFO_IN_PACKING',
      'ORDER_INFO_WAIT_UNPACK',
      'ORDER_INFO_SHIPPED',
    ].indexOf(currentOrder.status) !== -1;
  const showSendEmail =
    currentOrder.delivery &&
    ['СберМегаМаркет', 'OZON', 'Яндекс.Маркет'].indexOf(currentOrder.delivery.title) === -1;

  const handleClickCancel = () => {
    if (
      currentOrder.delivery.type !== 'SELF_PICKUP' ||
      currentWarehouse.operatorType === `FULFILLMENT`
    ) {
      handleCancel();
    } else {
      handleUpdateDeliveryResult('RETURNED');
    }
  };

  const handleOrderDeletingModal = () => {
    const actionName = currentOrder.status === 'ORDER_INFO_DRAFT' ? t('Удалить') : t('Отменить');
    dispatch(
      showModal('ClarifyModal', {
        submitCallback: handleClickCancel,
        actionName,
        content: (
          <p>{`${t('Вы действительно хотите')} ${actionName.toLowerCase()} ${t('заказ')}?`}</p>
        ),
      }),
    );
  };

  const handleImportAdditionalBarcodes = () => {
    dispatch(
      showModal('SimpleUpload', {
        title: t('Импорт доп. маркировки мест из Excel'),
        isSingle: true,
        accept: ['.xls', '.xlsx'],
        submitCallback: async (formData) => {
          formData.append('id', currentOrder.id);
          await dispatch(fetchUploadFbmStickersXls(formData)).then(async () => {
            await actualizeOrder(currentOrder.id);
            toast.info(t('Импорт успешно завершен'));
          });
        },
        handleGetTemplate: handleExportBarcodes,
      }),
    );
  };

  const handleImportPalletMarkExcel = () => {
    dispatch(
      showModal('SimpleUpload', {
        title: t('Импорт доп. маркировки паллет из Excel'),
        isSingle: true,
        accept: ['.xls', '.xlsx'],
        submitCallback: async (formData) => {
          formData.append('id', currentOrder.id);
          await dispatch(fetchUploadStickerPalletsExcel(formData)).then(async () => {
            await actualizeOrder(currentOrder.id);
            toast.info(t('Импорт успешно завершен'));
          });
        },
        handleGetTemplate: handleExportBarcodes,
      }),
    );
  };

  const handleExportBarcodes = async () => {
    const result = await dispatch(fetchGetFbmBarcodesXls(currentOrder.id));

    const fileData = result?.exportResults?.[0];
    if (fileData) {
      saveAs(fileData.fileUrl, fileData.fileID);
    }
  };

  const showImport = true;

  const showRecall = true;

  const showSale = true;

  const showExportExcel = true;

  const showInvoice =
    currentWarehouse?.operatorType === 'FULFILLMENT' && currentOrder?.warehouseFFSync;

  const showImportAdditionalBarcodes =
    checkIsFbm(currentOrder?.delivery, deliveryInfo) &&
    currentOrder.status === 'ORDER_INFO_PACKED_DOCUMENTS_REQUIRED';

  if (
    !showUploadFulfillment &&
    !showDelivery &&
    !showReturn &&
    !haveProductsWithoutReserve &&
    !showCopy &&
    !showCancel &&
    !showSendEmail &&
    !showImport &&
    !showRecall &&
    !showSale &&
    !showExportExcel &&
    !showInvoice &&
    !showImportAdditionalBarcodes
  )
    return null;

  const handleRefreshExpirationDate = async () => {
    const tokens = authData.tokenData;
    const body = { items: [] };

    for (let i = 0; i < itemsWithUseExpiration.length; i++) {
      body.items.push({
        id: itemsWithUseExpiration[i].variantId,
        fbmType: currentDelivery[0]?.fbmType || null,
      });

      if (worksheetShipmentCode && currentDelivery[0]?.fbmType === 'RETAIL_NETWORK')
        body.items[i].fbmSubTypeCode = worksheetShipmentCode;
    }

    const result = await dispatch(fetchExpirationDaysCalculateBatch(body, tokens)).catch((error) =>
      console.error(`${t('Ошибка')}!`),
    );

    const res = result.result;

    for (let i = 0; i < res.length; i++) {
      for (let j = 0; j < itemsWithUseExpiration.length; j++) {
        if (parseInt(itemsWithUseExpiration[j].variantId) === parseInt(res[i].id)) {
          itemsWithUseExpiration[j].expirationDays = parseInt(res[i].value);
          itemsWithUseExpiration[j].expirationDaysPercent = parseInt(expirationDaysPercent);
        }
      }
    }

    const itemsWithoutExpiration = findUniqueObjects(currentOrder.items, itemsWithUseExpiration);

    const bodyToUpdate = {
      id: currentOrder.id,
      items: [...itemsWithUseExpiration, ...itemsWithoutExpiration],
    };

    await dispatch(fetchUpdateOrderItems(bodyToUpdate))
      .catch((error) =>
        toast.error(error.data.errors[0].message || `${t('Ошибка при обновлении ОСГ')}!`),
      )
      .then((result) => {
        if (result.items) {
          toast.info(t('Данные ОСГ успешно обновлены'));
        }
      });
  };

  const handleGetOrdersReturns = async () => {
    await dispatch(fetchGetOrdersReturns(currentOrder.id));
  };

  const handlePostOrdersReturns = async () => {
    const body = {
      orderId: currentOrder.id,
      // "date": "2022-03-10 11:17:24",
      files: [],
      items: currentOrder.items.map((item) => ({
        accountingAttributes: [],
        defective: false,
        name: item?.name,
        num: item?.num,
        quantity: item?.quantity,
        reclamation: false,
        variantId: item?.variantId,
      })),
      // "number": "1003",
      // "returnUnpackingVideos": [],
      type: 'RETURN',
    };
    const res = await dispatch(fetchPostOrdersReturns(body));
  };

  const handleDeleteOrdersReturns = async () => {
    const res = await dispatch(fetchDeletePostOrdersReturns(currentOrder.id));
  };

  const rollbackOrderToEdit = async () => {
    const body = {
      orderId: currentOrder.id,
    };

    try {
      await dispatch(fetchOrderRollbackToEdit(body));
      await actualizeOrder(currentOrder.id);
    } catch (error) {
      return;
    }
  };

  const isStickerTypeText =
    worksheetDataRequirements?.packing_sticker_type === 'TEXT' ||
    worksheetDataRequirements?.pallet_sticker_type === 'TEXT';

  const showButtonForRollbackBeforeLoadingDocuments =
    currentDelivery?.[0]?.fbmType &&
    (currentOrder.status === 'ORDER_INFO_PACKED_DOCUMENTS_UPLOADED' ||
      currentOrder.status === 'ORDER_INFO_PACKED' ||
      currentOrder.status === 'ORDER_INFO_SHIPPED');

  const rollbackBeforeLoadingDocuments = async () => {
    const body = {
      id: currentOrder.id,
      status: 'ORDER_INFO_PACKED_DOCUMENTS_REQUIRED',
    };

    try {
      await dispatch(fetchOrderRollbackBeforeLoadingDocuments(body));
      await actualizeOrder(currentOrder.id);
    } catch (error) {
      toast.error(error);
    }
  };

  const handleRemovetItemsWithNoReserves = async () => {
    const data = {
      id: currentOrder.id,
    };

    try {
      await dispatch(fetchPostOrderReserveRepair(data));
    } catch (error) {}
  };

  const openConfirmationToCorrectReserve = () => {
    dispatch(
      showModal('RemoveItemsWithNoReserves', {
        submitCallback: handleRemovetItemsWithNoReserves,
        title: `${t('Заказ')} #${currentOrder.id}`,
        actionName: t('Да'),
        content: (
          <p>
            {t(
              'Данное действие уберет из заказа все товары под которые не хватает резервов или свободных остатков. Подтверждаете?',
            )}
          </p>
        ),
      }),
    );
  };

  const updateDataFromWMS = async () => {
    try {
      await dispatch(fetchPostOrderUpdateStatusFromWMS({ id: currentOrder.id }));
    } catch (error) {}
  };

  return (
    <div className={`btn-group ${showActions ? 'show' : ''}`} ref={ref}>
      <button
        type="button"
        className="btn btn-light dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        onClick={() => setShowActions(!showActions)}
        style={shorted && { width: 35, padding: `7px` }}
      >
        {shorted ? (
          <i className="fe-more-vertical" />
        ) : (
          <>
            {t('Действия')}
            <i className="mdi mdi-chevron-down" />
          </>
        )}
      </button>
      <div className={`dropdown-menu ${showActions ? 'show' : ''}`} x-placement="bottom-start">
        {showUploadFulfillment ? (
          <DropDownItem
            withoutPermission
            action={handleUploadToFulfillment}
            icon="fe-arrow-right"
            style={{ color: '#1abc9c' }}
            text={t('Выгрузить на фулфилмент')}
          />
        ) : null}

        {showDelivery ? (
          <DropDownItem
            permissions={permissions}
            permissionKey="DELIVER_COURIER"
            action={handleSetDelivery}
            icon="fe-truck"
            text={t('Доставить заказ')}
          />
        ) : null}

        {showReturn ? (
          <DropDownItem
            permissions={permissions}
            permissionKey="ACCEPT_RETURN"
            action={handleAcceptReturn}
            icon="fe-corner-up-left"
            text={t('Принять возврат')}
          />
        ) : null}

        {haveProductsWithoutReserve &&
        (defaultReserveOrders || (!defaultReserveOrders && currentOrder.needReserve)) ? (
          <DropDownItem
            permissions={permissions}
            permissionKey="REFRESH_RESERVE"
            action={handleRefreshReserve}
            icon="fe-rotate-ccw"
            text={t('Обновить резерв')}
          />
        ) : null}

        {isItemsWithUseExpiration() && showExpirationDate(currentOrder) ? (
          <DropDownItem
            action={handleRefreshExpirationDate}
            icon="fe-rotate-ccw"
            text={t('Обновить ОСГ по расчетным срокам')}
          />
        ) : null}

        {/* {isItemsWithUseExpiration() && showExpirationDate(currentOrder) ? (
          <DropDownItem
            action={showEditMultipleExpirationDatesModal}
            icon="fe-arrow-up"
            text={t('Задать единый ОСГ')}
          />
        ) : null} */}

        {showCopy ? (
          <DropDownItem
            permissions={permissions}
            permissionKey="COPY"
            action={handleCopyOrder}
            icon="fe-copy"
            text={t('Копировать')}
          />
        ) : null}

        {showImport ? (
          <DropDownItem
            withoutPermission
            action={handleImportFromExcel}
            icon="fe-arrow-up"
            text={t('Импорт товаров из Excel')}
          />
        ) : null}

        {showSendEmail ? (
          <DropDownItem
            withoutPermission
            action={handleSendEmail}
            icon="fe-mail"
            text={t('Отправить оповещение по email')}
          />
        ) : null}

        {showRecall ? (
          <DropDownItem
            withoutPermission
            action={handleOpenPhoneCallBack}
            icon="fe-phone-call"
            text={t('Перезвонить')}
          />
        ) : null}

        {showSale ? (
          <DropDownItem
            withoutPermission
            action={handleOpenEditSale}
            icon="fe-percent"
            text={t('Добавить скидку')}
          />
        ) : null}

        {showExportExcel ? (
          <DropDownItem
            withoutPermission
            action={handleExportExcel}
            icon="fe-file-text"
            text={t('Экспорт в Excel')}
          />
        ) : null}

        {usePackingMaterials ? (
          <DropDownItem
            withoutPermission
            action={handleApplyPreferredPacking}
            icon="fe-file"
            text={t('Применить желаемые упаковочные материалы')}
          />
        ) : null}

        {showInvoice ? (
          <DropDownItem
            withoutPermission
            action={handleInvoice}
            icon="fe-file"
            text={t('Инвойс')}
          />
        ) : null}

        {showImportAdditionalBarcodes && isStickerTypeText ? (
          <>
            <DropDownItem
              withoutPermission
              action={handleImportAdditionalBarcodes}
              icon="fe-file-text"
              text={t('Импорт доп. маркировки мест из Excel')}
            />
          </>
        ) : null}

        {showImportAdditionalBarcodes && isStickerTypeText ? (
          <>
            <DropDownItem
              withoutPermission
              action={handleImportPalletMarkExcel}
              icon="fe-file-text"
              text={t('Импорт доп. маркировки паллет из Excel')}
            />
          </>
        ) : null}

        {adminPanel === 'true' && (
          <>
            <SelectOrderType>
              <SelectComponent
                label={t('Установить тип заказа')}
                options={ORDER_TYPE}
                value={ORDER_TYPE.find((o) => o.value === currentOrder.orderType)}
                onChange={(e) =>
                  dispatch(
                    fetchUpdateOrderType({
                      id: currentOrder.c,
                      orderType: e.value,
                    }),
                  )
                }
              />
              <label className="admin-button" onClick={rollbackOrderToEdit}>
                {t('Вернуть к редактированию')}
              </label>
              {showButtonForRollbackBeforeLoadingDocuments ? (
                <label className="admin-button" onClick={rollbackBeforeLoadingDocuments}>
                  {t('FBO. Откатить до загрузки документов')}
                </label>
              ) : null}
              <label className="admin-button" onClick={openConfirmationToCorrectReserve}>
                {t('Скорректировать под доступные резервы')}
              </label>
              {currentOrder.orderSubType === 'BERU_TEST' && currentOrder.orderType === 'CUSTOM' ? (
                <ExecuteYMTestScenario
                  currentOrderId={currentOrder.id}
                  actualizeOrder={actualizeOrder}
                />
              ) : null}
              <EditOrderStatus currentOrderId={currentOrder.id} actualizeOrder={actualizeOrder} />
              <label className="admin-button" onClick={updateDataFromWMS}>
                {t('Обновить данные с WMS')}
              </label>
            </SelectOrderType>
          </>
        )}
        {showCancel ? (
          <>
            {showUploadFulfillment || showDelivery || showReturn ? (
              <div className="dropdown-divider" />
            ) : null}
            <DropDownItem
              permissions={permissions}
              permissionKey="CANCEL"
              action={handleOrderDeletingModal}
              style={{ color: '#f1556c' }}
              icon="fe-trash-2"
              text={currentOrder.status === 'ORDER_INFO_DRAFT' ? t('Удалить') : t('Отменить')}
            />
          </>
        ) : null}
        <DropDownItem
          // withoutPermission
          action={handleGetOrdersReturns}
          icon="fe-rotate-ccw"
          text={t('Получить возврат')}
        />

        <DropDownItem
          // withoutPermission
          action={handlePostOrdersReturns}
          icon="fe-rotate-ccw"
          text={t('Создать возврат')}
        />

        <DropDownItem
          // withoutPermission
          action={handleDeleteOrdersReturns}
          icon="fe-rotate-ccw"
          text={t('Удалить возврат')}
        />
      </div>
    </div>
  );
};

export default ActionsMenuButton;
